<template>
  <div class="version-details">
    <ModulesForVersionList
      v-bind:version="versionObj"
      v-bind:title="`Modules available in ${computedVersionName} version`"/>
  </div>
</template>

<script>
import ModuleEntity from '../store/entity/Version';
import ModulesForVersionList from './EntityList/ModulesForVersionList.vue';

export default {
  name: 'versiondetails',
  components: { ModulesForVersionList },
  data() {
    return {
      versionEntity: ModuleEntity,
      versionName: '',
      version: {},
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    computedVersionName() {
      return this.versionName;
    },
    versionObj() {
      return this.version;
    },
  },
  methods: {
    getVersionName() {
      this.$http.get(`api/versions/${this.id}`).then((response) => {
        this.version = response.data;
        this.versionName = response.data.name;
      });
    },
  },
  created() {
    this.getVersionName();
  },
};
</script>

<style scoped>

</style>
